import React from "react";
import { Button } from "@nef/core";

import StyledRegistrationButton from "../../../../styles/RegistrationButton.styles";

const RegistrationButton = (props: any) => {
  const { children } = props;
  return (
    <>
      <StyledRegistrationButton id="registration-button" to="/register">
        <Button>{children}</Button>
      </StyledRegistrationButton>
    </>
  );
};

export default RegistrationButton;
